export default __webpack_public_path__ + "static/media/iso.b9a003d6.jpg";